import env from '@config/env';
import { useEffect, useState } from 'react';
import './MaintenanceMode.scss';

const STORAGE_KEY = 'cloudflare_banner_dismissed';

const MaintenanceMode = () => {
  const [isDismissed, setIsDismissed] = useState(true);
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const shouldShow = env.SHOW_CLOUDFLARE_BANNER === 'true';
    const wasDismissed = localStorage.getItem(STORAGE_KEY) === 'true';

    if (shouldShow && !wasDismissed) {
      setIsDismissed(false);
      setIsVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    setIsClosing(true);
    if (typeof window !== 'undefined') {
      localStorage.setItem(STORAGE_KEY, 'true');
    }
    // Wait for animation to complete before hiding
    setTimeout(() => {
      setIsVisible(false);
      setIsDismissed(true);
    }, 300);
  };

  if (isDismissed || !isVisible) {
    return null;
  }

  return (
    <div
      className={`maintenance-mode-banner ${isClosing ? 'maintenance-mode-banner--closing' : ''}`}
      role="alert"
      aria-live="polite"
    >
      <div className="maintenance-mode-banner__container">
        <div className="maintenance-mode-banner__content">
          <span className="maintenance-mode-banner__icon" aria-hidden="true">
            ⚠️
          </span>
          <p className="maintenance-mode-banner__text">
            <strong>Cartedo</strong> is currently experiencing loading issues due to a Cloudflare
            outage. We&apos;re working to fix it. Some users may not be able to access the platform.
          </p>
        </div>
        <button
          onClick={handleDismiss}
          className="maintenance-mode-banner__close"
          aria-label="Dismiss banner"
        >
          <svg
            className="maintenance-mode-banner__close-icon"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default MaintenanceMode;
